import type { FC } from 'react';
import { useDesktop } from '@utils/hooks/useDesktop';
import NavBarMobile from './NavBarMobile';
import NavBarDesktopV3 from './NavBarDesktopV3';

const NavBar: FC = () => {
  const isDesktop = useDesktop();

  return isDesktop ? <NavBarDesktopV3 /> : <NavBarMobile />;
};

export default NavBar;
